import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonService } from '../../../core/services/common.service';
import { environment } from '../../../../environments/environment.development';
import { loginApiConstants } from '../../../shared/constants/loginConstants';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  BASE_API_URL = environment.BASE_API_URL;
  
  constructor(private readonly commonService: CommonService) { }

  login(data: any): Observable<any> {
    const url = this.BASE_API_URL + loginApiConstants.login
    return this.commonService.post(url, data)
  }

  logout(userId: any): Observable<any> {
    const url = this.BASE_API_URL
    return this.commonService.post(url, userId)
  }

}
